import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeService } from '../../../../services/employees.service';
import { SkillsModalComponent } from '../skills-modal/skills-modal.component';

@Component({
  selector: 'app-succession-modal',
  templateUrl: './succession-modal.component.html',
  styleUrls: ['./succession-modal.component.scss']
})
export class SuccessionModalComponent {
  @Input() employeeId!: number;
  suggestedSuccessors: any[] = [];
  @Output() successorAssigned = new EventEmitter<void>();
  isLoading = false; // Loading state
  activeSkillViewId: number | null = null;

  constructor(
    public activeModal: NgbActiveModal, 
    private employeeService: EmployeeService,
    private modalService: NgbModal) {}

  ngOnInit() {
    this.fetchSuggestedSuccessors();
  }

  fetchSuggestedSuccessors() {
    this.isLoading = true; // Show loader
    this.employeeService.getSuggestedSuccessors(this.employeeId)
      .subscribe(successors => {
        this.suggestedSuccessors = successors || [];
        this.isLoading = false; // Hide loader
      }, error => {
        this.isLoading = false; // Hide loader on error
      });
  }

  assignSuccessor(successor: any) {
    if (successor.already_assigned) return;

    this.employeeService.assignSuccessor(this.employeeId, successor.id)
      .subscribe(response => {
        console.log('Successor Assigned:', response);
        successor.already_assigned = true; // Mark as assigned
        this.successorAssigned.emit(); // Notify parent component
        this.activeModal.close();
      }, error => this.activeModal.close());
  }

  toggleSkillView(id: number) {
    this.activeSkillViewId = this.activeSkillViewId === id ? null : id;
  }
  
  openSkillsModal(successor: any) {
    const modalRef = this.modalService.open(SkillsModalComponent, { size: 'md' });
    modalRef.componentInstance.name = successor.full_name;
    modalRef.componentInstance.matchedSkills = successor.matched_skills;
    modalRef.componentInstance.unmatchedSkills = successor.unmatched_skills;
  }  
}
